




import Vue from 'vue'

import { Chart, registerables } from 'chart.js'
Chart.register(...registerables)

const chartAreaBorder = {
  id: 'chartAreaBorder',
  beforeDraw(chart:any, args:any, options:any) {
    const { ctx, chartArea: { left, top, width, height } } = chart;
    // Draw chart border
    ctx.save();
    ctx.strokeStyle = options.borderColor;
    ctx.lineWidth = options.borderWidth;
    ctx.setLineDash(options.borderDash || []);
    ctx.lineDashOffset = options.borderDashOffset;
    ctx.strokeRect(left, top, width, height);
    ctx.restore();
  }
}

export default Vue.component('chart', {
  data () {
    return {
      chart: null
    }
  },
  mounted (this:any) {
    this.generateChart()
  },
  props: {
    id: String,
    type: String,
    data: Object,
    options: Object
  },
  // If any of the following store values are changed
  // then the chart will update
  computed: {},
  // Generate the chart using the passed properties
  // id, data and options - update data & options
  methods: {
    generateChart: function (this:any) {
      var ctx = document.getElementById(this.id)
      this.chart = new Chart(ctx, {
        type: this.type,
        data: this.data,
        options: this.options,
        plugins: [chartAreaBorder]
      })
    },
    updateChart: function (this:any) {
      this.chart.data = this.data
      this.chart.options = this.options
    }
  },
  // Watch for changes in the above computed models,
  // call update functions on change
  watch: {}
})
